import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ReduxWrapper from '@store/ReduxWrapper';
import { MsalProvider } from '@azure/msal-react';
import utc from 'dayjs/plugin/utc';
import dayjs from 'dayjs';
import { msalInstance } from '@api/msalInstance';
import './translations/translation';

dayjs.extend(utc);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <MsalProvider instance={msalInstance}>
    <ReduxWrapper>
      <App />
    </ReduxWrapper>
  </MsalProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
